// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1eeccaed","453":"0b75785e","732":"30b91338","977":"f67b9838"}[chunkId] + ".chunk.js";
};